/**
 * @param {string} dateString - Date in RFC3339
 * @returns {string} - Date in format: MMM DD, YYYY
 */
const getFormattedDateString = dateString => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);
  const dateOptions = {
    year: 'numeric',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  };

  return date.toLocaleDateString('en-US', dateOptions);
};

export default getFormattedDateString;
